import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { role } from 'common/general'

const PrivateRouteAdmin = ({ authenticate, isRole }) => {
    return authenticate && (isRole === role.ADMIN || isRole === role.STAFF) ? <Outlet /> : <Navigate to="/" />

}

export default PrivateRouteAdmin